import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@craft/shared'
import { logout } from '../lib/firebase'
import Logo from '../components/Logo'

// ── カリキュラム定義（ここに追加していく） ───────────────────────────

const CURRICULUM = [
  {
    id: 'basics',
    type: 'read',
    category: 'Git 基礎',
    icon: '🌱',
    color: '#10B981',
    desc: 'Gitを使い始める前に知っておくべき基本概念。図と動きで直感的に理解する。',
    items: [
      {
        icon: '🌿',
        title: 'ブランチとは何か',
        desc: 'コミット履歴の分岐・並行作業の仕組みを3ステップで視覚的に理解する',
        href: '/content/concept.html',
        mins: 5,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '📦',
        title: 'add / commit の仕組み',
        desc: '作業ディレクトリ → ステージング → コミット済みの3段階をアニメーションで体験',
        href: '/content/concept.html',
        mins: 5,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '⬇️',
        title: 'fetch / pull の違い',
        desc: 'リモートとのやり取りで混乱しがちな2コマンドを図解で整理。新聞の比喩で覚える',
        href: '/content/concept.html',
        mins: 5,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '🏷️',
        title: 'タグとリリースの仕組み',
        desc: 'v1.0.0 などのバージョンタグを打つ意味と、リリースブランチとの違い',
        href: '/content/git-tag.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
    ],
  },
  {
    id: 'team',
    type: 'read',
    category: 'チーム開発の基本',
    icon: '🤝',
    color: '#3B8BD4',
    desc: 'チームでGitを使うときに必ず知っておくべき知識。現場でつまずく前に押さえる。',
    items: [
      {
        icon: '📋',
        title: 'プルリクエストの全体像',
        desc: 'ブランチを切ってPRを出してマージするまでの流れを6ステップで完全解説',
        href: '/content/concept.html',
        mins: 8,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '💥',
        title: 'コンフリクトの仕組みと解消法',
        desc: '<<<<<<< HEAD が出ても焦らない。衝突マーカーの読み方と解消手順を実践',
        href: '/content/concept.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🗺️',
        title: 'ブランチ戦略（Git Flow / GitHub Flow）',
        desc: 'チームのGit運用ルールを理解する。プロジェクト規模別にどちらを選ぶべきか',
        href: '/content/branch-strategy.html',
        mins: 10,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '👀',
        title: 'コードレビューの作法',
        desc: '良いレビューコメントの書き方、指摘の受け方。チームの信頼関係を育てる',
        href: '#',
        mins: 10,
        difficulty: 2,
        status: 'coming-soon',
      },
      {
        icon: '📋',
        title: 'CONTRIBUTING.md の書き方',
        desc: '環境構築・PR手順・コミット規約を明文化。チームの暗黙知をなくす',
        href: '/content/contributing.html',
        mins: 8,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '📐',
        title: 'チームのGitルールを設計する',
        desc: 'ブランチ命名・PRテンプレート・CODEOWNERS。入ってすぐ動けるチームを作る',
        href: '/content/team-rules.html',
        mins: 10,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '📝',
        title: 'コミットメッセージの書き方',
        desc: 'Conventional Commits規約。feat/fix/docsの使い方とCHANGELOG自動生成',
        href: '/content/commit-message.html',
        mins: 8,
        difficulty: 1,
        status: 'available',
      },
    ],
  },
  {
    id: 'scenarios',
    type: 'scenario',
    category: 'シナリオ演習',
    icon: '🎮',
    color: '#F59E0B',
    desc: '実際のチーム開発シナリオをチャット形式で追体験。「現場あるある」を安全な環境で練習。',
    items: [
      {
        icon: '🔰',
        title: '初めてのPR',
        desc: 'ブランチを切り・コミットし・PRを作り・レビューされ・マージされるまで一連で体験',
        href: '/content/simulator.html',
        mins: 10,
        difficulty: 1,
        tag: '基本',
        tagColor: '#185FA5',
        tagBg: '#E6F1FB',
        status: 'available',
      },
      {
        icon: '😱',
        title: 'コンフリクト発生！どうする？',
        desc: '同僚が同じファイルを変更してマージ済み。CONFLICT の解消を実際に体験',
        href: '/content/simulator.html',
        mins: 10,
        difficulty: 2,
        tag: 'トラブル',
        tagColor: '#854F0B',
        tagBg: '#FAEEDA',
        status: 'available',
      },
      {
        icon: '💬',
        title: 'レビュー指摘に対応する',
        desc: '関数名・ループ最適化を指摘された。修正してプッシュしてLGTMをもらうまで',
        href: '/content/simulator.html',
        mins: 10,
        difficulty: 2,
        tag: 'レビュー',
        tagColor: '#3B6D11',
        tagBg: '#EAF3DE',
        status: 'available',
      },
      {
        icon: '🚨',
        title: '緊急 hotfix 対応',
        desc: '本番でバグ発生！mainからhotfixブランチを切って即対応・即デプロイ',
        href: '/content/simulator.html',
        mins: 10,
        difficulty: 3,
        tag: '緊急対応',
        tagColor: '#A32D2D',
        tagBg: '#FCEBEB',
        status: 'available',
      },
      {
        icon: '🏷️',
        title: 'リリース準備とタグ打ち',
        desc: 'リリースブランチの作成・最終チェック・タグ付け・本番デプロイの一連の流れ',
        href: '/content/simulator.html',
        mins: 15,
        difficulty: 3,
        tag: 'リリース',
        tagColor: '#4A1D96',
        tagBg: '#EDE8F5',
        status: 'available',
        note: 'シナリオ5',
      },
      {
        icon: '🔧',
        title: '大規模リファクタの分割PR戦略',
        desc: '1000行変更のPRを出したら「分割して」と言われた。どう対応する？',
        href: '/content/simulator.html',
        mins: 15,
        difficulty: 3,
        tag: 'レビュー',
        tagColor: '#3B6D11',
        tagBg: '#EAF3DE',
        status: 'available',
        note: 'シナリオ7',
      },
      {
        icon: '😤',
        title: 'force push してしまった',
        desc: 'リモートのmainを上書きしてしまった。チームへの影響と復旧手順',
        href: '/content/simulator.html',
        mins: 12,
        difficulty: 3,
        tag: 'トラブル',
        tagColor: '#854F0B',
        tagBg: '#FAEEDA',
        status: 'available',
        note: 'シナリオ6',
      },
      {
        icon: '🔄',
        title: '長期ブランチをmainに追いつかせる',
        desc: '2週間放置したフィーチャーブランチ。大量のコンフリクトをどう解消するか',
        href: '/content/simulator.html',
        mins: 15,
        difficulty: 4,
        tag: 'トラブル',
        tagColor: '#854F0B',
        tagBg: '#FAEEDA',
        status: 'available',
        note: 'シナリオ8',
      },
      {
        icon: '⏪',
        title: '本番ミス！revert vs reset どっちを使う？',
        desc: 'mainに問題のコミットが入ってしまった。履歴を守りながら取り消す正しい方法',
        href: '/content/simulator.html',
        mins: 12,
        difficulty: 3,
        tag: 'トラブル',
        tagColor: '#854F0B',
        tagBg: '#FAEEDA',
        status: 'available',
        note: 'シナリオ9',
      },
      {
        icon: '🌐',
        title: 'OSS に初めてコントリビュートする',
        desc: 'fork・ブランチ・PR・upstream sync まで一連のOSS貢献フローを体験',
        href: '/content/simulator.html',
        mins: 15,
        difficulty: 3,
        tag: 'GitHub',
        tagColor: '#185FA5',
        tagBg: '#E6F1FB',
        status: 'available',
        note: 'シナリオ10',
      },
      {
        icon: '🍒',
        title: 'cherry-pick で hotfix を develop にも反映',
        desc: 'mainに当てた修正をdevelopにも取り込みたい。cherry-pickで特定コミットだけ持ってくる',
        href: '/content/simulator.html',
        mins: 10,
        difficulty: 3,
        tag: '上級',
        tagColor: '#4A1D96',
        tagBg: '#EDE8F5',
        status: 'available',
        note: 'シナリオ11',
      },
      {
        icon: '🔑',
        title: '.env を push してしまった！緊急対処',
        desc: '秘密鍵をコミット＆pushしてしまった最悪のケース。履歴削除・キーローテーションまで',
        href: '/content/simulator.html',
        mins: 12,
        difficulty: 4,
        tag: 'セキュリティ',
        tagColor: '#A32D2D',
        tagBg: '#FCEBEB',
        status: 'available',
        note: 'シナリオ12',
      },
    ],
  },
  {
    id: 'advanced',
    type: 'read',
    category: '中・上級テクニック',
    icon: '⚡',
    color: '#8B5CF6',
    desc: '知ってるだけでチームの評価が上がるGitテクニック。現場のベテランが使う技を習得。',
    items: [
      {
        icon: '🔀',
        title: 'rebase vs merge を使い分ける',
        desc: '履歴をきれいに保つrebase。mergeとの違い・危険性・使いどころを完全理解',
        href: '/content/rebase.html',
        mins: 12,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '📥',
        title: 'git stash で作業を一時退避',
        desc: '急な割り込み対応に必須。stash / pop / apply / list の使い方と落とし穴',
        href: '/content/stash.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🍒',
        title: 'cherry-pick で特定コミットを取り込む',
        desc: 'hotfixをdevelopにも適用したい。特定のコミットだけを別ブランチに持っていく技',
        href: '/content/cherry-pick.html',
        mins: 8,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '🔍',
        title: 'git bisect でバグの混入を特定する',
        desc: '「いつからバグってたの？」を二分探索で高速特定。100コミットも10回で特定',
        href: '/content/bisect.html',
        mins: 10,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '✨',
        title: 'interactive rebase で履歴を整える',
        desc: 'squash・reword・reorder・drop でコミット履歴を美しく。PR前の必須テクニック',
        href: '/content/interactive-rebase.html',
        mins: 15,
        difficulty: 4,
        status: 'available',
      },
      {
        icon: '🪝',
        title: 'Git Hooks で自動チェックを入れる',
        desc: 'pre-commit でlint・テスト・コミットメッセージの形式チェックを自動化',
        href: '/content/git-hooks.html',
        mins: 12,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '🔄',
        title: 'git reflog — 消えたコミットを復元する',
        desc: 'reset --hard で消えたコミットも復活できる。HEADの移動履歴を使いこなす',
        href: '/content/reflog.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🚫',
        title: '.gitignore の正しい書き方',
        desc: '何を無視すべきか・パターン記法・すでにトラッキング済みの解除方法',
        href: '/content/gitignore.html',
        mins: 6,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '🏷️',
        title: 'git tag — バージョン管理とリリース',
        desc: 'v1.0.0 タグの打ち方。軽量タグ vs 注釈付きタグ・リモートへのプッシュ',
        href: '/content/git-tag.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '📦',
        title: 'git submodule — 外部リポジトリを取り込む',
        desc: 'リポジトリ内に別のリポジトリを埋め込む仕組みと落とし穴',
        href: '/content/git-submodule.html',
        mins: 10,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '🌲',
        title: 'git worktree — 複数ブランチを同時作業',
        desc: 'ブランチ切り替えなしに別ディレクトリで並行作業。上級者の必須テクニック',
        href: '/content/git-worktree.html',
        mins: 8,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '🔍',
        title: 'git blame — 誰がいつ何を変えたか追う',
        desc: 'バグの混入を追跡・コードの意図を理解する。pickaxe 検索・GitLens 活用法',
        href: '/content/git-blame.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
    ],
  },
  {
    id: 'quiz',
    type: 'quiz',
    category: 'クイズ',
    icon: '🎯',
    color: '#EC4899',
    desc: '選択肢形式でGit知識をチェック。カテゴリを選んで4問ずつ解ける。',
    items: [
      {
        icon: '🌱',
        title: 'Git基礎クイズ',
        desc: 'fetch/pull・stash・reflog・HEADの基本コマンドの使い分けを確認',
        href: '/content/quiz.html#basics',
        mins: 5,
        difficulty: 1,
        status: 'available',
      },
      {
        icon: '🤝',
        title: 'チーム開発クイズ',
        desc: 'コンフリクト・revert/reset・force push・cherry-pick の判断力を問う',
        href: '/content/quiz.html#team',
        mins: 5,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '⚡',
        title: '上級テクニッククイズ',
        desc: 'bisect・annotated tag・Conventional Commits・worktree の理解度チェック',
        href: '/content/quiz.html#advanced',
        mins: 5,
        difficulty: 3,
        status: 'available',
      },
    ],
  },
  {
    id: 'exercises',
    type: 'quiz',
    category: '実践演習',
    icon: '🎲',
    color: '#F97316',
    desc: '読む・選ぶだけじゃない。diff読み解き・並び替え・レビュー・ブランチ図で実践力を鍛える。',
    items: [
      {
        icon: '🔍',
        title: 'diff読み解き',
        desc: '実際のコードdiffを見て「このコミットは何をしているか」を当てる。コードレビュー力を養う',
        href: '/content/diff.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '↕️',
        title: '操作手順 並び替え',
        desc: 'コンフリクト解消・PR作成・hotfix対応の手順カードを正しい順に並べる',
        href: '/content/sort.html',
        mins: 8,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🌿',
        title: 'ブランチ図 読み解き',
        desc: 'git logのASCIIグラフを見て「このブランチ構造から何が読み取れるか」を問う',
        href: '/content/branch.html',
        mins: 8,
        difficulty: 3,
        status: 'available',
      },
      {
        icon: '👀',
        title: 'PRレビュー シミュレーター',
        desc: 'コードdiffを見て「どのレビューコメントが適切か」を選ぶ。レビュワー視点を育てる',
        href: '/content/review.html',
        mins: 10,
        difficulty: 3,
        status: 'available',
      },
    ],
  },
  {
    id: 'flowchart',
    type: 'flowchart',
    category: 'トラブル診断フロー',
    icon: '🗺️',
    color: '#0EA5E9',
    desc: 'Gitでトラブルが起きたとき、何をすべきか分岐選択で学ぶ。現場での判断力を養う。',
    items: [
      {
        icon: '🔧',
        title: 'コミットをやり直したい',
        desc: 'push前/後・共有ブランチかどうかで正しい手順が変わる。状況別の正解へ導く診断',
        href: '/content/flowchart.html#commit',
        mins: 5,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '💥',
        title: 'コンフリクトが起きた',
        desc: 'merge中・rebase中・pull中で対処法が違う。状況に応じた正しいコマンドへ',
        href: '/content/flowchart.html#conflict',
        mins: 5,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🚨',
        title: '本番でバグが出た',
        desc: '原因コミット特定済みか・push済みかで revert/reset/bisect を使い分ける',
        href: '/content/flowchart.html#bugfix',
        mins: 5,
        difficulty: 3,
        status: 'available',
      },
    ],
  },
  {
    id: 'github',
    type: 'read',
    category: 'GitHub 活用術',
    icon: '🐙',
    color: '#6366F1',
    desc: 'Git だけでなく GitHub の機能を使いこなす。個人開発からチーム開発・OSS活動まで。',
    items: [
      {
        icon: '⚙️',
        title: 'GitHub Actions — CI/CDを自動化する',
        desc: 'push・PR・スケジュールをトリガーにテスト・デプロイを自動実行',
        href: '/content/github-actions.html',
        mins: 12,
        difficulty: 2,
        status: 'available',
      },
      {
        icon: '🌐',
        title: 'OSSに初めてコントリビュートする',
        desc: 'Fork → PR → マージされるまでの完全ガイド。good first issue から始める',
        href: '/content/oss-contribution.html',
        mins: 10,
        difficulty: 2,
        status: 'available',
      },
    ],
  },
]

// ── コンポーネント ───────────────────────────────────────────

function DifficultyDots({ level }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="w-1.5 h-1.5 rounded-full"
          style={{ background: i <= level ? '#10B981' : 'rgba(255,255,255,0.12)' }} />
      ))}
    </div>
  )
}

function ContentItem({ item }) {
  const isAvailable = item.status === 'available'
  const isScenario = item.href?.includes('simulator')
  const isQuiz = item.href?.includes('quiz')
  const isFlowchart = item.href?.includes('flowchart')

  const isDiff     = item.href?.includes('diff')
  const isSort     = item.href?.includes('sort')
  const isBranch   = item.href?.includes('branch')
  const isReview   = item.href?.includes('review')

  const typeBadge = isScenario
    ? { label: '🎮 シナリオ',    bg: '#F59E0B22', color: '#F59E0B', border: '#F59E0B44' }
    : isQuiz
    ? { label: '🎯 クイズ',      bg: '#EC489922', color: '#EC4899', border: '#EC489944' }
    : isFlowchart
    ? { label: '🗺️ フロー診断', bg: '#0EA5E922', color: '#0EA5E9', border: '#0EA5E944' }
    : isDiff
    ? { label: '🔍 diff読み解き',bg: '#F9731622', color: '#F97316', border: '#F9731644' }
    : isSort
    ? { label: '↕️ 並び替え',    bg: '#F9731622', color: '#F97316', border: '#F9731644' }
    : isBranch
    ? { label: '🌿 ブランチ図',  bg: '#F9731622', color: '#F97316', border: '#F9731644' }
    : isReview
    ? { label: '👀 PRレビュー',  bg: '#F9731622', color: '#F97316', border: '#F9731644' }
    : { label: '📖 解説',        bg: '#10B98122', color: '#10B981', border: '#10B98144' }

  const Inner = (
    <div
      className="p-4 rounded-xl flex gap-3 items-start transition-all"
      style={{
        background: isAvailable ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.02)',
        border: `1px solid ${isAvailable ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.05)'}`,
        opacity: isAvailable ? 1 : 0.55,
        cursor: isAvailable ? 'pointer' : 'default',
      }}
    >
      <span className="text-2xl shrink-0 mt-0.5">{item.icon}</span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap mb-1">
          {/* コンテンツ種別バッジ */}
          <span className="text-[10px] font-bold px-1.5 py-0.5 rounded"
            style={{ background: typeBadge.bg, color: typeBadge.color, border: `1px solid ${typeBadge.border}` }}>
            {typeBadge.label}
          </span>
          <span className="text-white font-semibold text-sm">{item.title}</span>
          {item.tag && (
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded"
              style={{ background: item.tagBg, color: item.tagColor }}>
              {item.tag}
            </span>
          )}
          {!isAvailable && (
            <span className="text-[10px] text-white/30 border border-white/10 px-1.5 py-0.5 rounded">近日公開</span>
          )}
        </div>
        <p className="text-white/45 text-xs leading-relaxed mb-2">{item.desc}</p>
        <div className="flex items-center gap-3">
          <DifficultyDots level={item.difficulty} />
          <span className="text-white/25 text-xs">約{item.mins}分</span>
          <span className="text-[10px] font-bold" style={{ color: '#10B981' }}>無料</span>
          {item.note && (
            <span className="text-[10px] text-white/30 border border-white/10 px-1.5 py-0.5 rounded">{item.note}</span>
          )}
        </div>
      </div>
      {isAvailable && (
        <div className="text-white/30 text-sm shrink-0 mt-1">→</div>
      )}
    </div>
  )

  if (!isAvailable) return Inner
  return (
    <a href={item.href}
      className="block hover:-translate-y-0.5 transition-transform">
      {Inner}
    </a>
  )
}

const TABS = [
  { id: 'read',      label: '📖 読み物',      desc: '解説・図解で学ぶ' },
  { id: 'scenario',  label: '🎮 シナリオ演習', desc: 'チャット形式で体験' },
  { id: 'quiz',      label: '🎯 クイズ',       desc: '知識を選択式で確認' },
  { id: 'flowchart', label: '🗺️ 診断フロー',  desc: 'トラブルを分岐診断' },
]

export default function DashboardPage() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [activeTab, setActiveTab] = useState('read')
  const [openSections, setOpenSections] = useState(new Set(['basics', 'scenarios', 'quiz', 'flowchart']))

  const toggleSection = (id) => {
    setOpenSections(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  const filteredSections = CURRICULUM.filter(s => s.type === activeTab)
  const totalAvailable = CURRICULUM.flatMap(c => c.items).filter(i => i.status === 'available').length
  const totalItems = CURRICULUM.flatMap(c => c.items).length

  return (
    <div
      className="min-h-screen"
      style={{
        background: 'linear-gradient(180deg, #0a0e1a 0%, #111827 100%)',
        fontFamily: "'Noto Sans JP', 'Inter', sans-serif",
      }}
    >
      {/* Nav */}
      <nav className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-white/10">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/')} className="text-white/50 hover:text-white text-sm transition-colors">
            ← トップ
          </button>
          <Logo size="md" />
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-white/40 hidden sm:inline">{user?.email}</span>
          <button onClick={() => logout()} className="text-xs text-white/30 hover:text-white transition-colors">
            ログアウト
          </button>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 md:px-8 py-10">

        {/* ヘッダー */}
        <div className="mb-8">
          <h1 className="text-3xl font-black text-white mb-1">カリキュラム</h1>
          <p className="text-white/40 text-sm mb-4">個人開発からチーム開発へ。Gitを現場レベルで使いこなす。</p>
          <div className="flex items-center gap-3">
            <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.07)' }}>
              <div className="h-full rounded-full transition-all"
                style={{ width: `${(totalAvailable / totalItems) * 100}%`, background: 'linear-gradient(90deg, #10B981, #059669)' }} />
            </div>
            <span className="text-xs text-white/40 shrink-0">{totalAvailable} / {totalItems} 公開中</span>
          </div>
        </div>

        {/* タブ切り替え */}
        <div className="grid grid-cols-2 gap-3 mb-8">
          {TABS.map(tab => {
            const isActive = activeTab === tab.id
            const accentMap = { read: '#10B981', scenario: '#F59E0B', quiz: '#EC4899', flowchart: '#0EA5E9' }
            const accent = accentMap[tab.id]
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className="p-4 rounded-2xl text-left transition-all"
                style={{
                  background: isActive ? `${accent}18` : 'rgba(255,255,255,0.03)',
                  border: `2px solid ${isActive ? accent : 'rgba(255,255,255,0.08)'}`,
                }}
              >
                <div className="text-base font-black mb-0.5" style={{ color: isActive ? accent : 'rgba(255,255,255,0.5)' }}>
                  {tab.label}
                </div>
                <div className="text-xs" style={{ color: isActive ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.25)' }}>
                  {tab.desc}
                </div>
              </button>
            )
          })}
        </div>

        {/* アコーディオン形式のセクション一覧 */}
        <div className="space-y-3">
          {filteredSections.map((section) => {
            const isOpen = openSections.has(section.id)
            const availableCount = section.items.filter(i => i.status === 'available').length
            return (
              <div key={section.id} className="rounded-2xl overflow-hidden"
                style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
                {/* アコーディオンヘッダー */}
                <button
                  onClick={() => toggleSection(section.id)}
                  className="w-full flex items-center gap-3 p-4 text-left transition-all"
                  style={{ background: isOpen ? `${section.color}12` : 'rgba(255,255,255,0.02)' }}
                >
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center text-xl shrink-0"
                    style={{ background: `${section.color}18`, border: `1px solid ${section.color}35` }}>
                    {section.icon}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h2 className="text-white font-black text-base leading-tight">{section.category}</h2>
                      <span className="text-[10px] text-white/30 shrink-0">{availableCount}コンテンツ</span>
                    </div>
                    <p className="text-white/35 text-xs mt-0.5 leading-relaxed truncate">{section.desc}</p>
                  </div>
                  <div className="text-white/30 text-sm shrink-0 transition-transform"
                    style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}>
                    →
                  </div>
                </button>

                {/* アコーディオン本体 */}
                {isOpen && (
                  <div className="p-3 pt-0 space-y-2"
                    style={{ background: 'rgba(0,0,0,0.15)' }}>
                    <div className="h-px mb-3" style={{ background: 'rgba(255,255,255,0.05)' }} />
                    {section.items.map((item) => (
                      <ContentItem key={item.title} item={item} />
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>

        {/* フッター */}
        <div className="mt-16 pt-8 border-t border-white/5 text-center">
          <p className="text-white/20 text-xs">コンテンツは順次追加予定。リクエストはトップページのお問い合わせから。</p>
        </div>
      </div>
    </div>
  )
}
